import {Localizer} from "../../../infrastructure/localization/localizer";
import {DatasetModel} from "../datasetModel";
import {RootTypeEnumTranslator, getAllTranslatedRootTypeEnums} from "../../../core/sharedmodels/laegeInstitution/rootTypeEnum";
import { Dispatch, SetStateAction, useEffect, useState } from "react";
import useStamdataApi from "core/hooks/useStamdataApi";
import useLogbogApi from "core/hooks/useLogbogApi";
import { ForSelectModel } from "core/sharedmodels/forSelectModel";
import FilterItemDetails from "./evalueringFilterItem";

type EvalueringsstatistikFilterDetailsProps = {
    dataset: DatasetModel
}

export const handleFetchAndSet = async (apiPromise: Promise<ForSelectModel[]>, setFunc: Dispatch<SetStateAction<string[] | undefined>>, preselectedIds?: string[]) => {
    const data = await apiPromise;
    setFunc(data.filter(x => !preselectedIds || preselectedIds?.length === 0 || preselectedIds.includes(x.id)).map(x => x.text));
}

export const EvalueringsstatistikFilterDetails = ({dataset}: EvalueringsstatistikFilterDetailsProps) => {

    const { evalueringstatistikApi } = useLogbogApi();
    const { stamdataLaegeinstitutionApi, stamdataUddannelseApi } = useStamdataApi();

    const [allSpecialer, setAllSpecialer] = useState<string[]>();
    const [allSygehuse, setAllSygehuse] = useState<string[]>();
    const [allRegioner, setAllRegioner] = useState<string[]>();
    const [allUdannelser, setAllUdannelser] = useState<string[]>();

    const third = Math.ceil(dataset.uddannelsessteder.length / 3);
    const firstHalf = dataset.uddannelsessteder?.slice(0, third);
    const secondHalf = dataset.uddannelsessteder?.slice(third, third * 2)
    const thirdHalf = dataset.uddannelsessteder.slice(third * 2)

    const uddannelsestypeValgt =  dataset.stillingsTypeName;

    useEffect(() => {
        handleFetchAndSet(evalueringstatistikApi.getSpecialerSelect(), setAllSpecialer, dataset.specialeIds);
    }, [dataset.specialeIds, evalueringstatistikApi]);

    useEffect(() => {
        handleFetchAndSet(stamdataLaegeinstitutionApi.getAllSygehuseSelect(), setAllSygehuse, dataset.sygehuse);
    }, [dataset.sygehuse, stamdataLaegeinstitutionApi]);

    useEffect(() => {
        handleFetchAndSet(evalueringstatistikApi.getRegionerSelect(), setAllRegioner, dataset.regioner);
    }, [dataset.regioner, evalueringstatistikApi]);

    useEffect(() => {
        if(uddannelsestypeValgt) return;
        handleFetchAndSet(stamdataUddannelseApi.getUddannelser(), setAllUdannelser);
    }, [stamdataUddannelseApi, uddannelsestypeValgt]);

    return (
        <div className="card-body border-top">
            <div className="d-flex wrap">
                <div className="flex-row flex-fill">
                    <h5>{Localizer.global_filter()}</h5>

                    <FilterItemDetails
                        text={Localizer.global_regioner()}
                        items={allRegioner}
                    />

                    <FilterItemDetails
                        text={Localizer.laegeinstitution()}
                        items={dataset.laegeinstitutionName ? [RootTypeEnumTranslator(dataset.laegeinstitutionName)] : getAllTranslatedRootTypeEnums()}
                    />

                    <FilterItemDetails
                        text={Localizer.sygehuse()}
                        items={allSygehuse}
                    />

                    <FilterItemDetails
                        text={Localizer.uddannelsesType()}
                        items={uddannelsestypeValgt ? dataset.stillingsTypeName : allUdannelser}
                    />

                    <FilterItemDetails
                        text={Localizer.global_speciale()}
                        items={allSpecialer}
                    />

                    <p className="margin-top-m wrap">{Localizer.uddannelsessteder()}</p>
                    <div className="row">
                        <div className="col-sm-4">
                            {!!firstHalf &&
                                <ul className="pl-3">
                                    {firstHalf?.map((uddannelsessted) =>
                                        <li key={uddannelsessted.id}>{uddannelsessted.navn}</li>
                                    )}
                                </ul>
                            }
                        </div>
                        <div className="col-sm-4">
                            {!!secondHalf &&
                                <ul className="pl-3">
                                    {secondHalf?.map((uddannelsessted) =>
                                        <li key={uddannelsessted.id}>{uddannelsessted.navn}</li>
                                    )}
                                </ul>
                            }
                        </div>

                        <div className="col-sm-4">
                            {!!thirdHalf &&
                                <ul className="pl-3">
                                    {thirdHalf?.map((uddannelsessted) =>
                                        <li key={uddannelsessted.id}>{uddannelsessted.navn}</li>
                                    )}
                                </ul>
                            }
                        </div>
                    </div>

                </div>
            </div>
        </div>
    )
}

